"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDateTimeFormat = void 0;
var _localeDataUtils = require("../../../localeDataUtils");
var getDateTimeFormat = exports.getDateTimeFormat = function getDateTimeFormat(locale) {
  return (0, _localeDataUtils.genericGetDateFormat)(locale);
};
//# sourceMappingURL=xm-admin.js.map